<ng-lottie
  style="height: 9vh; position: absolute; margin-top: -6vh; z-index: 1111; margin-left: -1vh; width: 9vh"
  [options]="options"
  (loopComplete)="onLoopComplete()"
></ng-lottie>
